import React from 'react';

const FacebookThin = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 35 35"
        width={props.width || 35}
        height={props.height || 35}
        aria-hidden="true"
        className={props.className}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.1298 4.46309C17.6535 2.93936 19.7201 2.08334 21.875 2.08334H26.25C26.7102 2.08334 27.0833 2.45643 27.0833 2.91667V8.75C27.0833 9.21024 26.7102 9.58334 26.25 9.58334H21.875C21.7092 9.58334 21.5503 9.64918 21.4331 9.7664C21.3158 9.88361 21.25 10.0426 21.25 10.2083V13.75H26.25C26.5066 13.75 26.7489 13.8682 26.9068 14.0705C27.0648 14.2728 27.1207 14.5365 27.0585 14.7854L25.6001 20.6188C25.5074 20.9898 25.1741 21.25 24.7917 21.25H21.25V32.0833C21.25 32.5436 20.8769 32.9167 20.4167 32.9167H14.5833C14.1231 32.9167 13.75 32.5436 13.75 32.0833V21.25H10.2083C9.7481 21.25 9.375 20.8769 9.375 20.4167V14.5833C9.375 14.1231 9.7481 13.75 10.2083 13.75H13.75V10.2083C13.75 8.05345 14.606 5.98683 16.1298 4.46309ZM21.875 3.75C20.1621 3.75 18.5194 4.43043 17.3083 5.6416C16.0971 6.85278 15.4167 8.49548 15.4167 10.2083V14.5833C15.4167 15.0436 15.0436 15.4167 14.5833 15.4167H11.0417V19.5833H14.5833C15.0436 19.5833 15.4167 19.9564 15.4167 20.4167V31.25H19.5833V20.4167C19.5833 19.9564 19.9564 19.5833 20.4167 19.5833H24.141L25.1827 15.4167H20.4167C19.9564 15.4167 19.5833 15.0436 19.5833 14.5833V10.2083C19.5833 9.60055 19.8248 9.01765 20.2545 8.58788C20.6843 8.15811 21.2672 7.91667 21.875 7.91667H25.4167V3.75H21.875Z"
            fill="currentColor"
        />
    </svg>
);

export default FacebookThin;



// WEBPACK FOOTER //
// ./src/base/icons/FacebookThin.jsx